"use strict";

var _slicedToArray = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _objectWithoutProperties = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _excluded = ["durationInFrames", "compositionHeight", "compositionWidth", "fps", "inputProps", "style", "controls", "loop", "autoPlay", "showVolumeControls", "allowFullscreen", "clickToPlay", "doubleClickToFullscreen", "spaceKeyToPlayOrPause", "moveToBeginningWhenEnded", "numberOfSharedAudioTags", "errorFallback", "playbackRate", "renderLoading", "className", "showPosterWhenUnplayed", "showPosterWhenEnded", "showPosterWhenPaused", "initialFrame", "renderPoster", "inFrame", "outFrame", "initiallyShowControls", "renderFullscreenButton", "renderPlayPauseButton"];

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Player = exports.componentOrNullIfLazy = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var remotion_1 = require("remotion");

var emitter_context_1 = require("./emitter-context");

var event_emitter_1 = require("./event-emitter");

var player_css_classname_1 = require("./player-css-classname");

var PlayerUI_1 = __importDefault(require("./PlayerUI"));

var SharedPlayerContext_1 = require("./SharedPlayerContext");

var validate_in_out_frame_1 = require("./utils/validate-in-out-frame");

var validate_initial_frame_1 = require("./utils/validate-initial-frame");

var validate_playbackrate_1 = require("./utils/validate-playbackrate");

var componentOrNullIfLazy = function componentOrNullIfLazy(props) {
  if ('component' in props) {
    return props.component;
  }

  return null;
};

exports.componentOrNullIfLazy = componentOrNullIfLazy;

var PlayerFn = function PlayerFn(_ref, ref) {
  var durationInFrames = _ref.durationInFrames,
      compositionHeight = _ref.compositionHeight,
      compositionWidth = _ref.compositionWidth,
      fps = _ref.fps,
      inputProps = _ref.inputProps,
      style = _ref.style,
      _ref$controls = _ref.controls,
      controls = _ref$controls === void 0 ? false : _ref$controls,
      _ref$loop = _ref.loop,
      loop = _ref$loop === void 0 ? false : _ref$loop,
      _ref$autoPlay = _ref.autoPlay,
      autoPlay = _ref$autoPlay === void 0 ? false : _ref$autoPlay,
      _ref$showVolumeContro = _ref.showVolumeControls,
      showVolumeControls = _ref$showVolumeContro === void 0 ? true : _ref$showVolumeContro,
      _ref$allowFullscreen = _ref.allowFullscreen,
      allowFullscreen = _ref$allowFullscreen === void 0 ? true : _ref$allowFullscreen,
      clickToPlay = _ref.clickToPlay,
      _ref$doubleClickToFul = _ref.doubleClickToFullscreen,
      doubleClickToFullscreen = _ref$doubleClickToFul === void 0 ? false : _ref$doubleClickToFul,
      _ref$spaceKeyToPlayOr = _ref.spaceKeyToPlayOrPause,
      spaceKeyToPlayOrPause = _ref$spaceKeyToPlayOr === void 0 ? true : _ref$spaceKeyToPlayOr,
      _ref$moveToBeginningW = _ref.moveToBeginningWhenEnded,
      moveToBeginningWhenEnded = _ref$moveToBeginningW === void 0 ? true : _ref$moveToBeginningW,
      _ref$numberOfSharedAu = _ref.numberOfSharedAudioTags,
      numberOfSharedAudioTags = _ref$numberOfSharedAu === void 0 ? 5 : _ref$numberOfSharedAu,
      _ref$errorFallback = _ref.errorFallback,
      errorFallback = _ref$errorFallback === void 0 ? function () {
    return '⚠️';
  } : _ref$errorFallback,
      _ref$playbackRate = _ref.playbackRate,
      playbackRate = _ref$playbackRate === void 0 ? 1 : _ref$playbackRate,
      renderLoading = _ref.renderLoading,
      className = _ref.className,
      showPosterWhenUnplayed = _ref.showPosterWhenUnplayed,
      showPosterWhenEnded = _ref.showPosterWhenEnded,
      showPosterWhenPaused = _ref.showPosterWhenPaused,
      initialFrame = _ref.initialFrame,
      renderPoster = _ref.renderPoster,
      inFrame = _ref.inFrame,
      outFrame = _ref.outFrame,
      initiallyShowControls = _ref.initiallyShowControls,
      renderFullscreenButton = _ref.renderFullscreenButton,
      renderPlayPauseButton = _ref.renderPlayPauseButton,
      componentProps = _objectWithoutProperties(_ref, _excluded);

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, react_1.useLayoutEffect)(function () {
      window.remotion_isPlayer = true;
    }, []);
  } // @ts-expect-error


  if (componentProps.defaultProps !== undefined) {
    throw new Error('The <Player /> component does not accept `defaultProps`, but some were passed. Use `inputProps` instead.');
  }

  var componentForValidation = (0, exports.componentOrNullIfLazy)(componentProps); // @ts-expect-error

  if ((componentForValidation === null || componentForValidation === void 0 ? void 0 : componentForValidation.type) === remotion_1.Composition) {
    throw new TypeError("'component' should not be an instance of <Composition/>. Pass the React component directly, and set the duration, fps and dimensions as separate props. See https://www.remotion.dev/docs/player/examples for an example.");
  }

  if (componentForValidation === remotion_1.Composition) {
    throw new TypeError("'component' must not be the 'Composition' component. Pass your own React component directly, and set the duration, fps and dimensions as separate props. See https://www.remotion.dev/docs/player/examples for an example.");
  }

  var component = remotion_1.Internals.useLazyComponent(componentProps);
  (0, validate_initial_frame_1.validateInitialFrame)({
    initialFrame: initialFrame,
    durationInFrames: durationInFrames
  });

  var _ref2 = (0, react_1.useState)(function () {
    return initialFrame !== null && initialFrame !== void 0 ? initialFrame : 0;
  }),
      _ref3 = _slicedToArray(_ref2, 2),
      frame = _ref3[0],
      setFrame = _ref3[1];

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      playing = _ref5[0],
      setPlaying = _ref5[1];

  var _ref6 = (0, react_1.useState)('player-comp'),
      _ref7 = _slicedToArray(_ref6, 1),
      rootId = _ref7[0];

  var _ref8 = (0, react_1.useState)(function () {
    return new event_emitter_1.PlayerEmitter();
  }),
      _ref9 = _slicedToArray(_ref8, 1),
      emitter = _ref9[0];

  var rootRef = (0, react_1.useRef)(null);
  var audioAndVideoTags = (0, react_1.useRef)([]);
  var imperativePlaying = (0, react_1.useRef)(false);

  if (typeof compositionHeight !== 'number') {
    throw new TypeError("'compositionHeight' must be a number but got '".concat(typeof compositionHeight, "' instead"));
  }

  if (typeof compositionWidth !== 'number') {
    throw new TypeError("'compositionWidth' must be a number but got '".concat(typeof compositionWidth, "' instead"));
  }

  remotion_1.Internals.validateDimension(compositionHeight, 'compositionHeight', 'of the <Player /> component');
  remotion_1.Internals.validateDimension(compositionWidth, 'compositionWidth', 'of the <Player /> component');
  remotion_1.Internals.validateDurationInFrames(durationInFrames, 'of the <Player/> component');
  remotion_1.Internals.validateFps(fps, 'as a prop of the <Player/> component', false);
  (0, validate_in_out_frame_1.validateInOutFrames)({
    durationInFrames: durationInFrames,
    inFrame: inFrame,
    outFrame: outFrame
  });

  if (typeof controls !== 'boolean' && typeof controls !== 'undefined') {
    throw new TypeError("'controls' must be a boolean or undefined but got '".concat(typeof controls, "' instead"));
  }

  if (typeof autoPlay !== 'boolean' && typeof autoPlay !== 'undefined') {
    throw new TypeError("'autoPlay' must be a boolean or undefined but got '".concat(typeof autoPlay, "' instead"));
  }

  if (typeof loop !== 'boolean' && typeof loop !== 'undefined') {
    throw new TypeError("'loop' must be a boolean or undefined but got '".concat(typeof loop, "' instead"));
  }

  if (typeof doubleClickToFullscreen !== 'boolean' && typeof doubleClickToFullscreen !== 'undefined') {
    throw new TypeError("'doubleClickToFullscreen' must be a boolean or undefined but got '".concat(typeof doubleClickToFullscreen, "' instead"));
  }

  if (typeof showVolumeControls !== 'boolean' && typeof showVolumeControls !== 'undefined') {
    throw new TypeError("'showVolumeControls' must be a boolean or undefined but got '".concat(typeof showVolumeControls, "' instead"));
  }

  if (typeof allowFullscreen !== 'boolean' && typeof allowFullscreen !== 'undefined') {
    throw new TypeError("'allowFullscreen' must be a boolean or undefined but got '".concat(typeof allowFullscreen, "' instead"));
  }

  if (typeof clickToPlay !== 'boolean' && typeof clickToPlay !== 'undefined') {
    throw new TypeError("'clickToPlay' must be a boolean or undefined but got '".concat(typeof clickToPlay, "' instead"));
  }

  if (typeof spaceKeyToPlayOrPause !== 'boolean' && typeof spaceKeyToPlayOrPause !== 'undefined') {
    throw new TypeError("'spaceKeyToPlayOrPause' must be a boolean or undefined but got '".concat(typeof spaceKeyToPlayOrPause, "' instead"));
  }

  if (typeof numberOfSharedAudioTags !== 'number' || numberOfSharedAudioTags % 1 !== 0 || !Number.isFinite(numberOfSharedAudioTags) || Number.isNaN(numberOfSharedAudioTags) || numberOfSharedAudioTags < 0) {
    throw new TypeError("'numberOfSharedAudioTags' must be an integer but got '".concat(numberOfSharedAudioTags, "' instead"));
  }

  (0, validate_playbackrate_1.validatePlaybackRate)(playbackRate);
  (0, react_1.useEffect)(function () {
    emitter.dispatchRatechange(playbackRate);
  }, [emitter, playbackRate]);
  (0, react_1.useImperativeHandle)(ref, function () {
    return rootRef.current;
  }, []);
  var timelineContextValue = (0, react_1.useMemo)(function () {
    return {
      frame: frame,
      playing: playing,
      rootId: rootId,
      shouldRegisterSequences: false,
      playbackRate: playbackRate,
      imperativePlaying: imperativePlaying,
      setPlaybackRate: function setPlaybackRate() {
        throw new Error('playback rate');
      },
      audioAndVideoTags: audioAndVideoTags
    };
  }, [frame, playbackRate, playing, rootId]);
  var setTimelineContextValue = (0, react_1.useMemo)(function () {
    return {
      setFrame: setFrame,
      setPlaying: setPlaying
    };
  }, [setFrame]);
  var passedInputProps = (0, react_1.useMemo)(function () {
    return inputProps !== null && inputProps !== void 0 ? inputProps : {};
  }, [inputProps]);

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, react_1.useLayoutEffect)(function () {
      // Inject CSS only on client, and also only after the Player has hydrated
      remotion_1.Internals.CSSUtils.injectCSS(remotion_1.Internals.CSSUtils.makeDefaultCSS(".".concat(player_css_classname_1.PLAYER_CSS_CLASSNAME), '#fff'));
    }, []);
  }

  return (0, jsx_runtime_1.jsx)(SharedPlayerContext_1.SharedPlayerContexts, {
    timelineContext: timelineContextValue,
    component: component,
    compositionHeight: compositionHeight,
    compositionWidth: compositionWidth,
    durationInFrames: durationInFrames,
    fps: fps,
    inputProps: inputProps,
    numberOfSharedAudioTags: numberOfSharedAudioTags,
    children: (0, jsx_runtime_1.jsx)(remotion_1.Internals.Timeline.SetTimelineContext.Provider, {
      value: setTimelineContextValue,
      children: (0, jsx_runtime_1.jsx)(emitter_context_1.PlayerEventEmitterContext.Provider, {
        value: emitter,
        children: (0, jsx_runtime_1.jsx)(PlayerUI_1.default, {
          ref: rootRef,
          renderLoading: renderLoading,
          autoPlay: Boolean(autoPlay),
          loop: Boolean(loop),
          controls: Boolean(controls),
          errorFallback: errorFallback,
          style: style,
          inputProps: passedInputProps,
          allowFullscreen: Boolean(allowFullscreen),
          moveToBeginningWhenEnded: Boolean(moveToBeginningWhenEnded),
          clickToPlay: typeof clickToPlay === 'boolean' ? clickToPlay : Boolean(controls),
          showVolumeControls: Boolean(showVolumeControls),
          doubleClickToFullscreen: Boolean(doubleClickToFullscreen),
          spaceKeyToPlayOrPause: Boolean(spaceKeyToPlayOrPause),
          playbackRate: playbackRate,
          className: className !== null && className !== void 0 ? className : undefined,
          showPosterWhenUnplayed: Boolean(showPosterWhenUnplayed),
          showPosterWhenEnded: Boolean(showPosterWhenEnded),
          showPosterWhenPaused: Boolean(showPosterWhenPaused),
          renderPoster: renderPoster,
          inFrame: inFrame !== null && inFrame !== void 0 ? inFrame : null,
          outFrame: outFrame !== null && outFrame !== void 0 ? outFrame : null,
          initiallyShowControls: initiallyShowControls !== null && initiallyShowControls !== void 0 ? initiallyShowControls : true,
          renderFullscreen: renderFullscreenButton !== null && renderFullscreenButton !== void 0 ? renderFullscreenButton : null,
          renderPlayPauseButton: renderPlayPauseButton !== null && renderPlayPauseButton !== void 0 ? renderPlayPauseButton : null
        })
      })
    })
  });
};

exports.Player = (0, react_1.forwardRef)(PlayerFn);